
import * as React from 'react';
import { Text } from 'react-native';
import storageData from '../../Data/StorageData';

export default props => <Text key={storageData.selected_language} {...props} style={[{  }, props.style]}>{props.children}</Text>